import React, { useState } from 'react'
import styled from 'styled-components';
import ToggleBtnImg  from '../../../assets/Admin_Portal/images/toggle_icon.svg'
import userSearch  from '../../../assets/Admin_Portal/images/userSearch.svg'
import Notification  from '../../../assets/Admin_Portal/images/headerNotification.svg'
import Dropdown from 'react-bootstrap/Dropdown';
import userImage from '../../../assets/Admin_Portal/images/userImage.png'

const NavBarCustom = styled.div`
height: 70px;
background: #ffffff;
width: calc(100vw - 300px);
margin-left: 300px;
border-bottom: 1px solid #ddd;

padding: 10px;
display: flex;
align-items: center;
justify-content: space-between;
transition: 250ms ease-in-out;
`

const ToggleBtn = styled.button`
height: 100%;
background: none;
border:0;
`

const HeaderUserSection = styled.div`
display: flex;
gap: 20px;
align-items: center;
`
const HeaderSeacrh = styled.span`

`
const HeaderNotification = styled.span`

`
const UserName = styled.p`
line-height: 15px;
text-align: start;
font-family: 'Poppins';
font-weight: 500;
`

const UserRole = styled.span`
font-size: 10px;
color: #999999;
`
const TopHeader = () => {

  const [navShow, setNavShow] = useState(false);

  let userName = localStorage.getItem("userName")
  // console.log("userName-->>>",userName)

  return (
    <NavBarCustom className={navShow ? "navShow" : ""}>
     <ToggleBtn onClick={() => setNavShow(!navShow)}>
      <img src={ToggleBtnImg} className='img-fluid ' alt="toggle"/>
     </ToggleBtn>
     <HeaderUserSection>
      <HeaderSeacrh><img src={userSearch} alt="Search" /></HeaderSeacrh>

      <HeaderNotification>
     <img src={Notification} alt="Search" />
     </HeaderNotification>

     <Dropdown>
      <Dropdown.Toggle className='d-flex align-items-center' variant="muted" id="dropdown-basic">
        <img src={userImage} className='img-fluid' alt="User Image"/>
        <UserName className='mx-3 mb-0'>{userName} <br/> 
        <UserRole>Admin</UserRole></UserName></Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#/action-1">Profile</Dropdown.Item>
        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Logout</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>

     </HeaderUserSection>
    </NavBarCustom>
  )
}

export default TopHeader;
